// V2-8: react-markdown 流式中途遇到无法解析的极端输入（如未闭合 ```mermaid, 嵌套 ``` 等）
// 会抛异常 → 整页崩。包一层 ErrorBoundary，catch 后降级为 <pre> 纯文本 + "渲染失败" 标。
//
// 关键：preact 的错误边界 API 跟 React 一致——组件类 + componentDidCatch + getDerivedStateFromError。

import { Component, ComponentChildren } from "preact";

interface Props {
  text: string;
  children: ComponentChildren;
}

interface State {
  err: Error | null;
}

export class MarkdownErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error) {
    // 控制台留个面包屑给后续调试
    console.error("[Markdown] render failed, fallback to plain text:", err);
  }

  /** 关键：text prop 变了 → reset error 状态，重试 render。
   *  没这个的话，一旦某条消息渲染挂了，整个气泡永远卡在错误态——下一个 delta 进来无法恢复。
   */
  componentDidUpdate(prevProps: Props) {
    if (this.state.err && prevProps.text !== this.props.text) {
      this.setState({ err: null });
    }
  }

  render() {
    if (this.state.err) {
      return (
        <div class="md-fallback">
          <div class="md-fallback__hint">⚠️ Markdown 渲染失败，降级为纯文本</div>
          <pre class="md-fallback__pre">{this.props.text}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
